import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Input
} from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import VirtualizedList from "./VirtualizedList";
import { areArraysEqual } from "../../../../../SupplierQuestionnaire/helpers";
import { getLowestFilteredDimensionKey } from "./helpers";

function DimensionFilterAccordionItem({ dimensionKey, data, setDimensionsItems, filtersData }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });
  const { id, name, items } = data;
  const lowestFilteredDimensionKey = getLowestFilteredDimensionKey(filtersData);

  const [selectedItemsIds, setSelectedItemsIds] = useState([]);
  const [searchDimValue, setSearchDimValue] = useState("");

  useEffect(() => {
    const foundFilterValue = Object.values(filtersData).find(filterValue => filterValue.dimensionId === id);
    if (typeof foundFilterValue !== "undefined") {
      if (!areArraysEqual(selectedItemsIds, foundFilterValue.items.map(item => item.id))) {
        setSelectedItemsIds(foundFilterValue.items.map(item => item.id));
      }
    } else if (selectedItemsIds.length !== 0) {
      setSelectedItemsIds([]);
    }
  }, [selectedItemsIds, filtersData, id]);

  const getDimensionItemsList = useCallback(() => {
    return items ?
      searchDimValue !== "" ?
        items.filter(item => item.name.toLowerCase().includes(searchDimValue.toLowerCase())) : items : [];
  }, [searchDimValue, items]);

  const itemClickHandler = (itemId) => {
    let itemsIds;
    if (!selectedItemsIds.includes(itemId)) {
      itemsIds = [
        ...selectedItemsIds,
        itemId
      ];
      setSelectedItemsIds(itemsIds);
    } else {
      itemsIds = selectedItemsIds.filter(el => el !== itemId);
      setSelectedItemsIds(itemsIds);
    }
    setDimensionsItems(itemsIds);
  };

  return (
    <AccordionItem>
      <h2>
        <AccordionButton backgroundColor={dimensionKey === lowestFilteredDimensionKey ? "esg_sub_active" : "white"}>
          <Box flex="1" textAlign="left" justifyContent="center">
            <Heading size="md">
              {`${name? "By "+name.toLowerCase() : (id? "id:"+id : "")} (${items?.length})`}
            </Heading>
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pt={2} pb={5} overflow="auto">
        <Input
          placeholder={t("search")}
          value={searchDimValue}
          onInput={(e) => {
            setSearchDimValue(e.target.value);
          }}
          marginBottom={3}
          borderRadius="none"
        />
        <VirtualizedList
          items={getDimensionItemsList()}
          itemClickHandler={itemClickHandler}
          selectedItemsIds={selectedItemsIds}
        />
      </AccordionPanel>
    </AccordionItem>
  );
}

export default DimensionFilterAccordionItem;